import React from 'react';
import PropTypes from 'prop-types';
import styled, {
    css,
    keyframes,
} from 'styled-components';
import Button from '@mlb/react-patterns/components/Button/button.tsx';

const spin = () => {

    return keyframes`
        100% {
            transform: rotate(360deg);
        }
    `;

};

const LoadingButton = styled(Button).attrs(({
    label,
    onClick,
    loading,
}) => ({
    size: 'md',
    label: label,
    loading: loading,
    handlers: loading ? {} : { onClick },
    shape: 'hollow',
    styleName: 'default',
    iconName: loading ? 'baseball': undefined,
    iconLeft: loading ? false: undefined,
}))`

    display: block;
    margin: 30px auto 0;
    padding: 0 25px;

    ${({ loading }) => loading && css`
        &&& {
            cursor: default;
            pointer-events: none;
            svg {
                width: 15px;
                height: 15px;
                -webkit-animation:${spin} 2s linear infinite;
                -moz-animation:${spin} 2s linear infinite;
                animation:${spin} 2s linear infinite;
                margin-top:1px;
            }
        }
    `}

`;

LoadingButton.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    loading: PropTypes.bool,
};

LoadingButton.defaultProps = {
    loading: false,
};

export default LoadingButton;
